import { render, staticRenderFns } from "./HomeDoc2.vue?vue&type=template&id=618fdc95&"
import script from "./HomeDoc2.vue?vue&type=script&lang=js&"
export * from "./HomeDoc2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports